(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      root.querySelectorAll('.ordcap-announcement-marquee:not([data-ready])').forEach((marquee) => {
        const track = marquee.querySelector('.ordcap-announcement-marquee__track');
        const group = marquee.querySelector('.ordcap-announcement-marquee__group');
        if (!track || !group || !group.children.length) return;

        group.querySelectorAll('[aria-hidden]').forEach((item) => item.setAttribute('aria-hidden', 'false'));
        const fill = () => {
          const groupWidth = group.getBoundingClientRect().width;
          if (!groupWidth) return;

          const speed = Number.parseFloat(track.style.getPropertyValue('--announcement-scroll-speed')) || 5;
          track.style.setProperty('--announcement-scroll-distance', `-${groupWidth}px`);
          track.style.setProperty('--announcement-scroll-duration', `${groupWidth / (30 + speed * 5)}s`);

          while (track.scrollWidth < marquee.clientWidth + groupWidth) {
            const copy = group.cloneNode(true);
            copy.setAttribute('aria-hidden', 'true');
            copy.querySelectorAll('a').forEach((link) => link.setAttribute('tabindex', '-1'));
            copy.querySelectorAll('[data-shopify-editor-block]').forEach((item) => item.removeAttribute('data-shopify-editor-block'));
            track.append(copy);
          }
          marquee.setAttribute('data-ready', '');
        };

        fill();
        if ('ResizeObserver' in window) {
          const observer = new ResizeObserver(fill);
          observer.observe(marquee);
          observer.observe(group);
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
    } else {
      initialize(document);
    }
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
